import React from 'react';
import { Box, Typography } from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';
import { appColors } from '../../Config/Theme';
import { formatDateTime } from '../../Utils/dateHelpers';

interface ClosedIncidentBannerProps {
  closedAtUtc?: string | null;
}

const ClosedIncidentBanner: React.FC<ClosedIncidentBannerProps> = ({ closedAtUtc }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
      bgcolor: '#E3F2FD',
      border: '1px solid #90CAF9',
      borderRadius: '10px',
      px: 2.5,
      py: 1.5,
      mb: 2,
    }}
  >
    <LockIcon sx={{ fontSize: 22, color: '#1565C0' }} />
    <Box>
      <Typography variant="body2" sx={{ fontWeight: 700, color: '#1565C0', lineHeight: 1.3 }}>
        This incident is closed. Data is read-only.
      </Typography>
      {closedAtUtc && (
        <Typography variant="caption" sx={{ color: '#1976D2' }}>
          Closed {formatDateTime(closedAtUtc)}.
        </Typography>
      )}
    </Box>
  </Box>
);

export default ClosedIncidentBanner;
